<app-spinner></app-spinner>
<router-outlet></router-outlet>

<!-- Global Floating Call Panel - persists across all routes -->
<app-global-call-panel></app-global-call-panel>

<app-celebration></app-celebration>

<app-sticky-notes-button
  *ngIf="auth.authState$ | async">
</app-sticky-notes-button>
